import * as React from 'react';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import { ParameterCustomInputProps } from './types';

const ParameterStringInput = ({
    value,
    setParameterValue,
    parameterName,
}: ParameterCustomInputProps): React.ReactElement => {
    // local state because debounce on setParameterValue disable real-time modification
    const [inputValue, setInputValue] = useState(value);
    // @ts-expect-error [TS migration] Was not detected by flow
    const onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
        setParameterValue(parameterName, e.target.value);
        setInputValue(e.target.value);
    };

    return (
        <TextField
            value={inputValue}
            onChange={onChange}
            className="parameter-value text"
            variant="outlined"
            margin="dense"
            size="small"
        />
    );
};

export default ParameterStringInput;
